
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-test-tokens",
      function () {
        return require("private-next-pages/get-test-tokens.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-test-tokens"])
      });
    }
  